import { render, staticRenderFns } from "./ActivitySpeaking.vue?vue&type=template&id=6cbf2750&scoped=true"
import script from "./ActivitySpeaking.vue?vue&type=script&lang=ts"
export * from "./ActivitySpeaking.vue?vue&type=script&lang=ts"
import style0 from "./ActivitySpeaking.vue?vue&type=style&index=0&id=6cbf2750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbf2750",
  null
  
)

export default component.exports